import {
  FETCH_ASSEMBLY_GUIDE_BY_ARTICLE_NUMBER,
  FETCH_ASSEMBLY_GUIDE_BY_ARTICLE_NUMBER_FAILURE,
  FETCH_ASSEMBLY_GUIDE_BY_ARTICLE_NUMBER_SUCCESS,
  RESET_TRACKED_ASSEMBLY_GUIDE,
} from "./assemblyGuideTypes";
export const fetchingState = {
  inProgress: "inProgress",
  success: "Success",
  failure: "Failure",
};
const initialState = {
  assemblyGuideByArticleNumber: {
    fetchingStatus: {
      state: undefined,
    },
    guide: undefined,
    error: undefined,
  },
};

const trackAssemblyGuideReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ASSEMBLY_GUIDE_BY_ARTICLE_NUMBER:
      return {
        ...state,
        assemblyGuideByArticleNumber: {
          ...state.assemblyGuideByArticleNumber,
          fetchingStatus: {
            state: fetchingState.inProgress,
          },
        },
      };
    case FETCH_ASSEMBLY_GUIDE_BY_ARTICLE_NUMBER_SUCCESS:
      return {
        ...state,
        assemblyGuideByArticleNumber: {
          ...state.assemblyGuideByArticleNumber,
          fetchingStatus: { state: fetchingState.success },
          guide: action.payload,
        },
      };
    case FETCH_ASSEMBLY_GUIDE_BY_ARTICLE_NUMBER_FAILURE:
      return {
        ...state,
        assemblyGuideByArticleNumber: {
          ...state.assemblyGuideByArticleNumber,
          fetchingStatus: {
            state: fetchingState.failure,
          },
          guide: undefined,
          error: action.payload,
        },
      };
    case RESET_TRACKED_ASSEMBLY_GUIDE: {
      return {
        ...state,
        assemblyGuideByArticleNumber: {
          ...initialState.assemblyGuideByArticleNumber,
        },
      };
    }
    default:
      return {
        ...state,
      };
  }
};

export default trackAssemblyGuideReducer;
